export default __webpack_public_path__ + "static/media/layer.4cf4a4b3.svg";